// extracted by mini-css-extract-plugin
module.exports = {"modal-header":"_2U8axW205NRIZKdc-hScGK","modal-dialog":"R8LGYAZ6u8NqTkgWgC_sZ"};